import React from "react";
import {Col, Grid, Panel, Row} from "react-bootstrap";
import {Tr} from "@esnpm/translate";

/*
	The whole shop while the mode is `maintenance` — no header, no catalog, no
	routes. Rendered by ShopApp in place of the application, so nothing that
	could talk to the API is mounted at all.
*/
export const MaintenanceView = () => (
	<Grid className={"MaintenanceView"}>
		<Row>
			<Col xs={12} md={8} mdOffset={2}>
				<Panel>
					<Panel.Heading>
						<Panel.Title componentClass={"h1"}>
							<Tr path={"shopMode.Maintenance.Headline"}/>
						</Panel.Title>
					</Panel.Heading>
					<Panel.Body>
						<p><Tr path={"shopMode.Maintenance.Explanation"}/></p>
						<p><Tr path={"shopMode.Maintenance.Contact"}/></p>
					</Panel.Body>
				</Panel>
			</Col>
		</Row>
	</Grid>
);

export default MaintenanceView;
